module.exports = __webpack_public_path__ + "img/CompScope_Bright_10.75d8ad1c.png";